class LeadDyno {
  constructor(leadDyno_k) {

    let s1 = document.createElement("script"), s0 = document.getElementsByTagName("body")[0];
    s1.src = 'https://static.leaddyno.com/js';
    s1.type = 'text/javascript';
    s0.appendChild(s1);

    setTimeout(() => {
      if (window.LeadDyno) {
        window.LeadDyno.key = leadDyno_k;
        window.LeadDyno.recordVisit();
        window.LeadDyno.autoWatch();
      }
    }, 1000);
  }
}

export default LeadDyno;



// WEBPACK FOOTER //
// ./src/services/lead-dyno.js